<!--赖传峰-->
<template>
  <div>
    <AsyncIpBlocked v-if="ipBlock" />
    <template v-else>
      <main class="main">
        <slot />
      </main>
    </template>
    <LoginDialog ref="loginDialog" />
  </div>
</template>

<script lang="ts" setup>
import { computed, defineAsyncComponent, provide, ref, useI18n, useRoute, watch, useSeoMeta } from '#imports'
import LoginDialog from '@/layouts/common/LoginDialog.vue'
import { useLayout } from '@/store/layout'
import { useUserInfo } from '@/store/userInfo'
import { InjectionKey, SupportLocale } from '@/types/enum'
import type { ComputedRef } from 'vue'
import { OG_SITE_NAME } from '~/types/constants'

const locale = useI18n().locale as ComputedRef<SupportLocale>

const loginDialog = ref<InstanceType<typeof LoginDialog>>()
const showLoginDialog: ShowLoginDialog = callback => loginDialog.value?.show(callback)
provide<ShowLoginDialog>(InjectionKey.SHOW_LOGIN_DIALOG, showLoginDialog)

const userInfoStore = useUserInfo()
const layoutStore = useLayout()

const AsyncIpBlocked = defineAsyncComponent(() => import('@/components/IpBlocked.vue'))

const ipBlock = computed(() => !!userInfoStore.ipBlock)

// FIXME 在 template 中不生效
watch([locale, useRoute()], () => {
  layoutStore.sidebarMobileVisible = false
})
useSeoMeta({
  ogSiteName: OG_SITE_NAME,
})
</script>

<style lang="less" scoped>
@import '@/assets/styles/util';

/* .drive-layout-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
} */

.drive-layout {
  display: flex;
  flex-direction: column;
  #no-select();
  height: var(--vh, 100vh);
}

.main {
  position: relative;
  flex: 1;
}
</style>

<style lang="less">
@import '@/assets/styles/util';

.shop-bg {
  background: url('@/assets/images/shop/shop-bg.jpg') no-repeat center/cover;
}

@media screen and (min-width: @mobile-break-width) {
  .need-passcode {
    background: url('@/assets/images/share/passcode-bg.jpeg') var(--no-repeat-center) / cover #e1f1fe;

    .header {
      border-bottom: none;
    }
  }
}
</style>
